import { axios } from 'src/api'
import { ApiSaveDataOfferParams } from './savedataoffer.types'

export const ApiSaveDataOffer = async ({
  serverPath,
  data
}: ApiSaveDataOfferParams) => {
  return await axios.post(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/savedataoffer`,
    data
  )
}
